<template>
	<nk-wrapper v-if="context.organisationseinheit" spacing="md">
		<nk-title tag="h2" size="2xl">
			{{ context.organisationseinheit.name }}
		</nk-title>
		<nk-box
			v-if="
				context.organisationseinheit.anschriften?.length ||
				context.organisationseinheit.oeffnungszeiten?.text
			"
		>
			<nk-row vertical-gutter="2" gutter="2">
				<nk-col
					v-if="context.organisationseinheit.anschriften[0]"
					cols="full"
					md="auto"
				>
					<nk-title size="lg">Adresse</nk-title>
					<nk-address
						variant="vertical"
						:strasse="`${context.organisationseinheit.anschriften[0].strasse} ${context.organisationseinheit.anschriften[0].hausnummer}`"
						:plz="context.organisationseinheit.anschriften[0].postleitzahl"
						:ort="context.organisationseinheit.anschriften[0].ort"
					/>
				</nk-col>
				<nk-col
					v-if="context.organisationseinheit.oeffnungszeiten.text"
					cols="full"
					md="auto"
				>
					<nk-title size="lg">Öffnungszeiten</nk-title>
					<div
						class="nk-cms-content"
						v-html="context.organisationseinheit.oeffnungszeiten.text"
					/>
				</nk-col>
			</nk-row>
		</nk-box>

		<nk-wrapper
			v-if="context.organisationseinheit.untergeordneteOEs.length"
			spacing="lg"
		>
			<template v-if="options.variant === 'minimal'">
				<nk-title tag="h2" size="xl">Fachbereiche</nk-title>
				<nk-template-service-bw-organisationseinheiten-minimal
					:nesting-level="1"
					:context="{
						taggingpfad: context.taggingpfad,
						taggingpfadMitarbeiter: context.taggingpfadMitarbeiter,
						organisationseinheiten:
							context.organisationseinheit.untergeordneteOEs,
					}"
					:options="options"
				/>
			</template>
			<template v-else>
				<nk-title tag="h2" size="xl">Untergeordnete Fachbereiche</nk-title>
				<nk-template-service-bw-organisationseinheiten
					:nesting-level="1"
					:options="options"
					:context="{
						taggingpfad: context.taggingpfad,
						taggingpfadMitarbeiter: context.taggingpfadMitarbeiter,
						organisationseinheiten:
							context.organisationseinheit.untergeordneteOEs,
					}"
				/>
			</template>
		</nk-wrapper>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {array} context.organisationseinheit
 * @prop {string} context.taggingpfad
 * @prop {string} context.taggingpfadMitarbeiter
 * @prop {string} options.variant
 */
export default {
	name: 'NkTemplateServiceBwOrganisationseinheit',

	mixins: [TemplatesDefault],
};
</script>
